import * as methods from '../methods';
import { Resource } from '../Resource';
const rootPath = 'auth/api-keys';
const fromRaw = {
    get: (raw) => ({
        id: raw.id,
        name: raw.name,
        createdAt: raw.created_at,
        key: raw.key
    })
};
export default Resource((requesterBuilder) => {
    const getMany = () => requesterBuilder({
        path: rootPath,
        requestCtx: {
            /**fake paginated to use components that expected paginated like adminclientlist */
            transform: (rawResults) => ({
                count: rawResults.length,
                results: rawResults.map(fromRaw.get),
                next: null,
                previous: null
            })
        }
    });
    return {
        getMany,
        create: methods.create({
            requesterBuilder,
            rootPath,
            fromRaw: fromRaw.get,
            toRaw: (form) => form,
            buildKeysToInvalidate: () => [getMany().invalidationKey]
        }),
        delete: methods.deletion({
            requesterBuilder,
            rootPath,
            buildKeysToInvalidate: () => [getMany().invalidationKey]
        })
    };
});
